import React, { useState } from "react";

import { VisibilityOffIcon, VisibilityOnIcon } from "@/modules/common/assets/icons";
import { cn } from "@/libs/cn";
import Input, { InputProps } from "../Input";

export type PasswordInputProps = Omit<InputProps, "type" | "maskType">;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  // A disabled field must not reveal its content either, so the toggle follows the input.
  const isVisibilityToggleEnabled = !props.disabled;
  const isRevealed = isVisible && isVisibilityToggleEnabled;

  return (
    <div className="relative">
      <Input type={isRevealed ? "text" : "password"} ref={ref} {...props} />
      <button
        type="button"
        disabled={!isVisibilityToggleEnabled}
        className={cn(
          "absolute right-3 bottom-2.5 text-gray-500",
          isVisibilityToggleEnabled ? "cursor-pointer" : "cursor-not-allowed opacity-50",
        )}
        onClick={() => setIsVisible((state) => !state)}
        aria-label={isRevealed ? "Ocultar senha" : "Mostrar senha"}
      >
        {isRevealed ? <VisibilityOnIcon className="h-5 w-5" /> : <VisibilityOffIcon className="h-5 w-5" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
